import Vue from 'vue'
import App from './App.vue'
import {teamNames, matchStatus, leagueNames} from './utils/translations'
import store from './store'
import './assets/sass/style.scss';
import router from './router'
import VueMeta from 'vue-meta'


Vue.config.productionTip = false

Vue.use({
    apiToken: '497a991e9574411996722e0e4ecb97cf',
    glossary: {...teamNames, ...matchStatus, ...leagueNames}, // می‌تونی teamNames و matchStatus رو اینجا هم پاس بدی
})

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})

new Vue({
    store,
    router,
    render: function (h) {
        return h(App)
    }
}).$mount('#app')